module.exports = __webpack_public_path__ + "static/media/archibot-clin-doeil.344ff091.gif";